/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Both marks now come from the kit; the local `.ld-dots` / `.ld-inline` CSS is gone.
 *
 * The two implementations drew the same three pulsing dots, one through a stylesheet and one
 * through Tailwind, and had already diverged on whether the animation respects
 * `prefers-reduced-motion` - the kit's does. The kit's `LoadingDots` gained the `size` prop this
 * app needs (4px inline in a panel header, 8px standing alone in an empty state).
 */
import { InlineLoading as KitInlineLoading, type InlineLoadingProps } from '@vaas/react-ui-kit';

export { LoadingDots, type LoadingDotsProps } from '@vaas/react-ui-kit';

/**
 * Dots plus their label, for the common "…is loading" line.
 *
 * Wrapped only to flip the kit's default indicator from a spinner to dots, which is what this
 * app's seven call sites have always shown. Pass `indicator="spinner"` to opt back out.
 */
export function InlineLoading({ indicator = 'dots', ...props }: InlineLoadingProps) {
  return <KitInlineLoading indicator={indicator} {...props} />;
}
